import React from 'react';
import './AccordionItem.css';

export interface Props {
  hasBar: boolean;
  text: string;
  heading: string;
  isExpanded: boolean;
  onClick(): void;
}

export default function AccordionItem(props: Props) {
  const { isExpanded, onClick, text, heading, hasBar } = props;
  let arrowClasses: string = 'accordion-item__arrw';
  arrowClasses += isExpanded ? ` accordion-item__arrw--dwn` : ` accordion-item__arrw--rght`;

  let accordionItem = 'accordion-item';
  accordionItem += hasBar ? ' accordion-item--border' : '';

  return (
    <div className={accordionItem}>
      <button className="accordion-item__button" onClick={onClick}>
        <span className={arrowClasses} />
        <span className="accordion-item__heading">{heading}</span>
      </button>
      {isExpanded && <div className="accordion-item__text">{text}</div>}
    </div>
  );
}
